module.exports = __webpack_public_path__ + "img/error.f736cfda.svg";